import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class SatisfactionSurveyMessageRecord extends BaseMessageRecord({
  type: "survey",

  /** @memberof SatisfactionSurveyMessageRecord# */
  messageTemplateId: null,

  /** @memberof SatisfactionSurveyMessageRecord# */
  multipleAllowed: false
}) {
  static getInvalidFields = () => Immutable.List()
}

export default SatisfactionSurveyMessageRecord;
